/**
 * When something happened, as a reader scans it: relative within a
 * day, the date after that — with the year once it is not this year's, so a pull
 * request left open for a year does not read like last week's. The exact time is
 * on hover. The date is British English, as the facts bar and the CI/CD tab
 * write theirs (`catalog/pipeline/format.ts`), not the browser's language: a
 * German browser would otherwise write "12. Sept." in an English page. The hover
 * still follows the browser, as the portal's other exact times do.
 *
 * Its own module since DX-307: the pull-request card, the attention card and
 * Recently used all write times this way, and the attention card's selection
 * is a pure function that should not import a card to do it.
 */
export const updatedLabel = (iso: string, now = Date.now()) => {
  const at = new Date(iso);
  const minutes = Math.floor((now - at.getTime()) / 60_000);
  if (minutes < 1) return 'just now';
  if (minutes < 60) return `${minutes} min ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} h ago`;
  const thisYear = at.getFullYear() === new Date(now).getFullYear();
  return at.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    ...(thisYear ? {} : { year: 'numeric' }),
  });
};
